import React, { useState, useEffect, Fragment } from "react";

import cardStyles from "assets/jss/material-dashboard-pro-react/components/cardStyle.js";

import { useDispatch, useSelector } from "react-redux";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import styles from "../../../../../assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import styles1 from "assets/jss/material-dashboard-pro-react/views/chartsStyle.js";

import { Tabs } from "antd";
import "antd/dist/antd.css";

import { useTranslation } from "react-i18next";
import "../../improvement.css";
import usePlannedCourses from "../../../../Components/usePlannedCourses";
import {
  fetchAnnualProgramReportById,
  UpdateAnnualProgramReport,
} from "../../../../../reduxToolkit/features/AnnualProgramReport/AnnualProgramReportSlice";

import GridContainer from "components/Grid/GridContainer.js";
// core components
import GridItem from "components/Grid/GridItem.js";

import { TableBody, TableRow, TableCell } from "@material-ui/core";
import { DataGrid } from "@mui/x-data-grid";
import AddVariationsCoursesModal from "../../../../Components/AddVariationsCoursesModal";

import {
  addNewPreviousActionPlan,
  fetchPreviousActionPlans,
  deletePreviousAction,
} from "../../../../../reduxToolkit/features/ActionPlan/ActionPlanSlice";
import {
  CloseOutlined,
  CheckOutlined,
  DeleteOutlined,
} from "@ant-design/icons";

import { unwrapResult } from "@reduxjs/toolkit";
import {
  fetchVariationsCourses,
  deleteVariationsCourse,
} from "../../../../../reduxToolkit/features/VariationsCourses/VariationsCoursesSlice.js";
import useTablePloResults from "../../../../Components/useTablePloResults";
const useStyles3 = makeStyles(styles1);
const { TabPane } = Tabs;

const useStyles = makeStyles((theme) => ({
  root: {
    width: "fit-content",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.secondary,
    "& svg": {
      margin: theme.spacing(1.5),
    },
    "& hr": {
      margin: theme.spacing(0, 0.5),
    },
  },
}));
const useStyles1 = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
}));
const useStyles2 = makeStyles(styles);
const useCardStyles = makeStyles(cardStyles);

const headCells = [
  { id: "Code", label: "Code" },
  { id: "Course", label: "Course" },
  { id: "Variation", label: "Variation" },
  { id: "Reasons for variation", label: "Reasons for variation" },
  { id: "Actions taken", label: "Actions taken" },
  { id: "delete", label: "" },
];

export default function CoursesWithVariations(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const classes1 = useStyles1();
  const classes2 = useStyles2();
  const classes3 = useStyles3();
  const dispatch = useDispatch();

  const [records, setRecords] = [];
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const { TblContainer, TblHead } = useTablePloResults(
    records,
    headCells,
    filterFn
  );
  let program_id =
    props.AnnualProgramReport &&
    props.AnnualProgramReport.programs &&
    props.AnnualProgramReport.programs[0] &&
    props.AnnualProgramReport.programs[0].id;
  useEffect(() => {
    dispatch(fetchVariationsCourses(program_id));
  }, []);

  const VariationsCourses = useSelector(
    (state) => state.VariationsCourses.VariationsCourses
  );
  const DeleteVariationsCourse = (id) => {
    dispatch(deleteVariationsCourse(id))
      .then(unwrapResult)
      .then(() => {
        dispatch(fetchVariationsCourses(program_id));
      });
  };
  const [pageSize, setPageSize] = React.useState(10);
  return (
    <div>
      <GridContainer xs={12} sm={12} md={12}>
        <GridItem key={Element.id} xs={12} sm={12} md={11}></GridItem>
        <GridItem key={Element.id} xs={12} sm={12} md={1}>
          <AddVariationsCoursesModal
            program_id={
              props.AnnualProgramReport &&
              props.AnnualProgramReport.programs &&
              props.AnnualProgramReport.programs[0] &&
              props.AnnualProgramReport.programs[0].id
            }
          />
        </GridItem>
      </GridContainer>

      <TblContainer style={{ marginTop: "0px", paddingTop: "0px" }}>
        <TblHead />
        <TableBody>
          {VariationsCourses &&
            VariationsCourses.map((item) => (
              <TableRow key={item.id}>
                <TableCell
                  className="multipleLine"
                  style={{ borderRight: "1px solid lightgray", borderLeft: "1px solid lightgray", }}
                >
                  {item && item.course_details && item.course_details.code}
                </TableCell>
                <TableCell
                  style={{

                    borderRight: "1px solid lightgray",
                  }}
                >
                  <p
                    style={{
                      display: "-webkit-box",
                      maxWidth: "200px",
                      WebkitLineClamp: 4,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {item && item.course_details && item.course_details.title}
                  </p>
                </TableCell>

                <TableCell
                  className="multipleLine"
                  style={{ borderRight: "1px solid lightgray" }}
                >
                  {item && item.variation}
                </TableCell>
                <TableCell
                  className="multipleLine"
                  style={{ borderRight: "1px solid lightgray" }}
                >
                  {item && item.reasons_for_variation}
                </TableCell>

                <TableCell
                  className="multipleLine"
                  style={{ borderRight: "1px solid lightgray" }}
                >
                  {item && item.actions_taken}
                </TableCell>

                <TableCell
                  style={{
                    borderRight: "1px solid lightgray",
                  }}
                >
                  <DeleteOutlined
                    onClick={() => DeleteVariationsCourse(item && item.id)}
                    style={{ color: "red" }}
                  />
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </TblContainer>
    </div>
  );
}
